import { Controller, useFormContext } from 'react-hook-form'
import { InternalIdInput } from '@library'
import { IconPickerField, type VectorIcon } from '@microservices/wiskey-react-components'
import { ICON_REGISTRY } from '@mobileConstants'
import { MobileApp } from '@mobileTypes'
import { ColorPickerField } from '@components/ColorPicker'
import { FormControlLabel, Grid, Switch, TextField, Tooltip, Typography } from '@mui/material'

export const BasicInfoForm = ({ isEdit = false }: { isEdit?: boolean }) => {
  const { control } = useFormContext<MobileApp>()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Controller
          name='internalId'
          control={control}
          rules={{ required: 'Internal ID is required' }}
          render={({ field, fieldState: { error } }) => (
            <InternalIdInput
              value={field.value ?? ''}
              onChange={field.onChange}
              fullWidth
              label='Internal ID'
              disabled={isEdit}
              error={!!error}
              helperText={error?.message}
              required
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name='title'
          control={control}
          rules={{ required: 'Title is required' }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              fullWidth
              label='App Title'
              error={!!error}
              helperText={error?.message}
              required
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name='icon'
          control={control}
          render={({ field }) => {
            const iconValue =
              typeof field.value === 'string'
                ? null
                : (field.value as VectorIcon | null | undefined) || null

            return (
              <IconPickerField
                value={iconValue}
                onChange={icon => field.onChange(icon ?? '')}
                label='App Icon'
                iconRegistry={ICON_REGISTRY}
              />
            )
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name='backgroundColor'
          control={control}
          render={({ field }) => (
            <ColorPickerField
              label='Background Color'
              value={field.value}
              onChange={field.onChange}
              helperText='Select background color'
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name='keepAwake'
          control={control}
          render={({ field }) => (
            <Tooltip title='Prevent the device screen from sleeping while this app is active'>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!field.value}
                    onChange={e => field.onChange(e.target.checked)}
                  />
                }
                label={
                  <Typography variant='body2'>
                    Keep Screen Awake
                  </Typography>
                }
              />
            </Tooltip>
          )}
        />
      </Grid>

    </Grid>
  )
}
